import React from 'react';
import { Link } from 'react-router-dom';
import {
    BarChart2, Download, Share2, Clock, Settings,
    ChevronLeft, Calendar, Filter, Sliders, Edit3,
    PieChart, BarChart, LineChart, TrendingUp, TrendingDown,
    Plus, ArrowRight, Zap, RefreshCw, HelpCircle,
    Bell, Users, Database, Home, ChevronDown, MessageSquare
} from 'lucide-react';

const LumiLogicDashboardDetail = () => {
    return (
        <div className="flex flex-col h-screen bg-gray-100">
            {/* Top Navigation Bar */}
            <header className="bg-gray-800 shadow-sm py-3 px-6 flex justify-between items-center">
                <div className="flex items-center space-x-10">
                    <div className="flex items-center">
                        <img src="/logo192.png" alt="LumiLogic Logo" className="w-auto h-8 mr-2" />
                        <span className="font-bold text-xl text-teal-300">LumiLogic</span>
                    </div>
                    <div className="hidden md:flex space-x-6">
                        <button className="nav-item px-3 py-1 text-sm font-medium rounded flex items-center text-teal-500 hover:bg-gray-700">
                            <Home size={16} className="mr-2" />
                            Dashboard
                        </button>
                        <Link to="/data-source" className="nav-item px-3 py-1 text-sm font-medium rounded flex items-center text-teal-500 hover:bg-gray-700">
                            <Database size={16} className="mr-2" />
                            Data Sources
                        </Link>
                        <button className="nav-item px-3 py-1 text-sm font-medium rounded flex items-center text-teal-500 hover:bg-gray-700">
                            <BarChart2 size={16} className="mr-2" />
                            Reports
                        </button>
                        <button className="nav-item px-3 py-1 text-sm font-medium rounded flex items-center text-teal-500 hover:bg-gray-700">
                            <Users size={16} className="mr-2" />
                            Team
                        </button>
                    </div>
                </div>
                <div className="flex items-center space-x-4">
                    <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-full relative">
                        <Bell size={20} />
                        <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
                    </button>
                    <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-full">
                        <HelpCircle size={20} />
                    </button>
                    <div className="flex items-center cursor-pointer">
                        <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center text-white font-medium">
                            KF
                        </div>
                        <ChevronDown size={16} className="ml-2 text-gray-500" />
                    </div>
                </div>
            </header>

            {/* Dashboard Header */}
            <div className="bg-white border-b border-gray-200 py-4 px-6">
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <Link to="/" className="mr-3 text-gray-500 hover:text-gray-700">
                            <ChevronLeft size={20} />
                        </Link>
                        <h1 className="text-xl font-bold text-gray-800">Marketing Performance Dashboard</h1>
                        <span className="ml-3 px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full">Custom</span>
                    </div>
                    <div className="flex items-center space-x-2">
                        <div className="flex items-center text-sm text-gray-500 mr-4">
                            <RefreshCw size={14} className="mr-1" />
                            <span>Updated 5 mins ago</span>
                        </div>
                        <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-md">
                            <Settings size={18} />
                        </button>
                        <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-md">
                            <Share2 size={18} />
                        </button>
                        <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-md">
                            <Edit3 size={18} />
                        </button>
                        <button className="flex items-center px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                            <Download size={16} className="mr-2" />
                            Export
                        </button>
                    </div>
                </div>
            </div>

            {/* Dashboard Controls */}
            <div className="bg-white border-b border-gray-200 px-6 py-3">
                <div className="flex justify-between items-center">
                    <div className="flex space-x-3">
                        <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 flex items-center bg-white hover:bg-gray-50">
                            <Calendar size={16} className="mr-2" />
                            Last 30 days
                            <ChevronDown size={16} className="ml-2" />
                        </button>
                        <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 flex items-center bg-white hover:bg-gray-50">
                            <Filter size={16} className="mr-2" />
                            Filters
                            <ChevronDown size={16} className="ml-2" />
                        </button>
                    </div>
                    <div className="flex items-center">
                        <button className="flex items-center text-blue-600 mr-4">
                            <Zap size={16} className="mr-1" />
                            Ask GlowSight AI
                        </button>
                        <button className="px-3 py-1 text-sm rounded border border-gray-300 text-gray-600 flex items-center bg-white hover:bg-gray-50">
                            <Sliders size={14} className="mr-2" />
                            Customize
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Dashboard Content */}
            <div className="flex-1 overflow-auto p-6">
                {/* First Row - Key Metrics */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="text-sm font-medium text-gray-500">Website Traffic</p>
                                <h3 className="text-2xl font-bold mt-1">12,594</h3>
                                <div className="flex items-center mt-2">
                  <span className="text-green-500 flex items-center text-sm">
                    <TrendingUp size={14} className="mr-1" />
                    18.2%
                  </span>
                                    <span className="text-xs text-gray-500 ml-2">vs last period</span>
                                </div>
                            </div>
                            <div className="p-2 bg-blue-50 rounded-md">
                                <LineChart size={20} className="text-blue-600" />
                            </div>
                        </div>
                    </div>

                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="text-sm font-medium text-gray-500">Social Engagement</p>
                                <h3 className="text-2xl font-bold mt-1">8,431</h3>
                                <div className="flex items-center mt-2">
                  <span className="text-green-500 flex items-center text-sm">
                    <TrendingUp size={14} className="mr-1" />
                    24.5%
                  </span>
                                    <span className="text-xs text-gray-500 ml-2">vs last period</span>
                                </div>
                            </div>
                            <div className="p-2 bg-purple-50 rounded-md">
                                <MessageSquare size={20} className="text-purple-600" />
                            </div>
                        </div>
                    </div>

                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="text-sm font-medium text-gray-500">Conversion Rate</p>
                                <h3 className="text-2xl font-bold mt-1">3.2%</h3>
                                <div className="flex items-center mt-2">
                  <span className="text-red-500 flex items-center text-sm">
                    <TrendingDown size={14} className="mr-1" />
                    0.5%
                  </span>
                                    <span className="text-xs text-gray-500 ml-2">vs last period</span>
                                </div>
                            </div>
                            <div className="p-2 bg-yellow-50 rounded-md">
                                <PieChart size={20} className="text-yellow-600" />
                            </div>
                        </div>
                    </div>

                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="text-sm font-medium text-gray-500">Cost Per Acquisition</p>
                                <h3 className="text-2xl font-bold mt-1">$42.18</h3>
                                <div className="flex items-center mt-2">
                  <span className="text-green-500 flex items-center text-sm">
                    <TrendingDown size={14} className="mr-1" />
                    12.3%
                  </span>
                                    <span className="text-xs text-gray-500 ml-2">vs last period</span>
                                </div>
                            </div>
                            <div className="p-2 bg-green-50 rounded-md">
                                <BarChart size={20} className="text-green-600" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Second Row - Charts */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    {/* Traffic Sources Chart */}
                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="font-medium text-gray-800">Traffic Sources</h3>
                            <button className="text-sm text-gray-500">
                                <Clock size={14} className="inline mr-1" />
                                Last 30 Days
                            </button>
                        </div>
                        <div className="h-64 flex items-center justify-center bg-gray-50 rounded-md">
                            <PieChart size={120} className="text-gray-300" />
                        </div>
                        <div className="mt-4 grid grid-cols-2 gap-2">
                            <div className="flex items-center">
                                <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                                <span className="text-sm text-gray-600">Organic Search (42%)</span>
                            </div>
                            <div className="flex items-center">
                                <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                                <span className="text-sm text-gray-600">Social Media (28%)</span>
                            </div>
                            <div className="flex items-center">
                                <div className="w-3 h-3 bg-yellow-500 rounded-full mr-2"></div>
                                <span className="text-sm text-gray-600">Direct (18%)</span>
                            </div>
                            <div className="flex items-center">
                                <div className="w-3 h-3 bg-purple-500 rounded-full mr-2"></div>
                                <span className="text-sm text-gray-600">Referral (12%)</span>
                            </div>
                        </div>
                    </div>

                    {/* Campaign Performance Chart */}
                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="font-medium text-gray-800">Campaign Performance</h3>
                            <button className="text-sm text-gray-500">
                                <Clock size={14} className="inline mr-1" />
                                Last 30 Days
                            </button>
                        </div>
                        <div className="h-64 flex items-center justify-center bg-gray-50 rounded-md">
                            <BarChart size={120} className="text-gray-300" />
                        </div>
                        <div className="mt-4">
                            <div className="flex items-center justify-between mb-2">
                                <div className="flex items-center">
                                    <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                                    <span className="text-sm text-gray-600">Spring Promotion</span>
                                </div>
                                <span className="text-sm font-medium">$12,450</span>
                            </div>
                            <div className="flex items-center justify-between mb-2">
                                <div className="flex items-center">
                                    <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                                    <span className="text-sm text-gray-600">Product Launch</span>
                                </div>
                                <span className="text-sm font-medium">$8,230</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <div className="w-3 h-3 bg-purple-500 rounded-full mr-2"></div>
                                    <span className="text-sm text-gray-600">Brand Awareness</span>
                                </div>
                                <span className="text-sm font-medium">$5,180</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Third Row - Audience Demographics & Conversion Funnel */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                    {/* Audience Demographics */}
                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="font-medium text-gray-800">Audience Demographics</h3>
                            <button className="text-gray-500 hover:text-gray-700">
                                <ChevronDown size={16} />
                            </button>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <h4 className="text-sm text-gray-500 mb-2">Age Groups</h4>
                                <div className="space-y-2">
                                    <div className="flex items-center">
                                        <span className="text-sm w-16">18-24</span>
                                        <div className="flex-1 mx-2">
                                            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                                <div className="h-2 bg-blue-500 rounded-full" style={{width: '15%'}}></div>
                                            </div>
                                        </div>
                                        <span className="text-sm w-8 text-right">15%</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="text-sm w-16">25-34</span>
                                        <div className="flex-1 mx-2">
                                            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                                <div className="h-2 bg-blue-500 rounded-full" style={{width: '38%'}}></div>
                                            </div>
                                        </div>
                                        <span className="text-sm w-8 text-right">38%</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="text-sm w-16">35-44</span>
                                        <div className="flex-1 mx-2">
                                            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                                <div className="h-2 bg-blue-500 rounded-full" style={{width: '27%'}}></div>
                                            </div>
                                        </div>
                                        <span className="text-sm w-8 text-right">27%</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="text-sm w-16">45-54</span>
                                        <div className="flex-1 mx-2">
                                            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                                <div className="h-2 bg-blue-500 rounded-full" style={{width: '12%'}}></div>
                                            </div>
                                        </div>
                                        <span className="text-sm w-8 text-right">12%</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span className="text-sm w-16">55+</span>
                                        <div className="flex-1 mx-2">
                                            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                                <div className="h-2 bg-blue-500 rounded-full" style={{width: '8%'}}></div>
                                            </div>
                                        </div>
                                        <span className="text-sm w-8 text-right">8%</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h4 className="text-sm text-gray-500 mb-2">Gender</h4>
                                <div className="flex items-center">
                                    <div className="w-32 h-32 relative">
                                        <PieChart size={128} className="text-gray-300" />
                                    </div>
                                    <div className="ml-4">
                                        <div className="flex items-center mb-2">
                                            <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                                            <span className="text-sm text-gray-600">Female (58%)</span>
                                        </div>
                                        <div className="flex items-center mb-2">
                                            <div className="w-3 h-3 bg-purple-500 rounded-full mr-2"></div>
                                            <span className="text-sm text-gray-600">Male (41%)</span>
                                        </div>
                                        <div className="flex items-center">
                                            <div className="w-3 h-3 bg-gray-500 rounded-full mr-2"></div>
                                            <span className="text-sm text-gray-600">Other (1%)</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Conversion Funnel */}
                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="font-medium text-gray-800">Conversion Funnel</h3>
                            <button className="text-gray-500 hover:text-gray-700">
                                <ChevronDown size={16} />
                            </button>
                        </div>
                        <div className="h-72 flex flex-col justify-between items-center">
                            <div className="w-full h-12 bg-blue-100 rounded-t-lg flex items-center px-4">
                                <span className="text-sm font-medium text-blue-800">Visitors (12,594)</span>
                                <span className="ml-auto text-xs text-blue-700">100%</span>
                            </div>
                            <div className="w-3/4 h-2 bg-blue-200"></div>
                            <div className="w-3/4 h-12 bg-blue-200 flex items-center px-4">
                                <span className="text-sm font-medium text-blue-800">Product Views (4,982)</span>
                                <span className="ml-auto text-xs text-blue-700">39.6%</span>
                            </div>
                            <div className="w-2/4 h-2 bg-blue-300"></div>
                            <div className="w-2/4 h-12 bg-blue-300 flex items-center px-4">
                                <span className="text-sm font-medium text-blue-800">Add to Cart (1,245)</span>
                                <span className="ml-auto text-xs text-blue-700">9.8%</span>
                            </div>
                            <div className="w-1/4 h-2 bg-blue-400"></div>
                            <div className="w-1/4 h-12 bg-blue-400 flex items-center px-4">
                                <span className="text-sm font-medium text-blue-800">Checkout (632)</span>
                                <span className="ml-auto text-xs text-blue-700">5.0%</span>
                            </div>
                            <div className="w-1/6 h-2 bg-blue-500"></div>
                            <div className="w-1/6 h-12 bg-blue-500 rounded-b-lg flex items-center px-4">
                                <span className="text-sm font-medium text-white">Purchase (403)</span>
                                <span className="ml-auto text-xs text-blue-100">3.2%</span>
                            </div>
                        </div>
                        <div className="mt-4">
                            <button className="text-sm text-blue-600 font-medium flex items-center">
                                View Detailed Funnel Analysis
                                <ArrowRight size={14} className="ml-1" />
                            </button>
                        </div>
                    </div>

                    {/* Channel Performance */}
                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="font-medium text-gray-800">Channel Performance</h3>
                            <button className="text-gray-500 hover:text-gray-700">
                                <ChevronDown size={16} />
                            </button>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <h4 className="text-sm font-medium">Facebook</h4>
                                    <span className="text-sm font-medium text-blue-600">$0.45 CPC</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                    <div className="h-2 bg-blue-600 rounded-full" style={{width: '65%'}}></div>
                                </div>
                                <div className="flex justify-between text-xs text-gray-500 mt-1">
                                    <span>3,245 clicks</span>
                                    <span>2.4% CTR</span>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <h4 className="text-sm font-medium">Instagram</h4>
                                    <span className="text-sm font-medium text-purple-600">$0.72 CPC</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                    <div className="h-2 bg-purple-600 rounded-full" style={{width: '78%'}}></div>
                                </div>
                                <div className="flex justify-between text-xs text-gray-500 mt-1">
                                    <span>2,832 clicks</span>
                                    <span>3.7% CTR</span>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <h4 className="text-sm font-medium">Google Ads</h4>
                                    <span className="text-sm font-medium text-red-600">$1.20 CPC</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                    <div className="h-2 bg-red-600 rounded-full" style={{width: '42%'}}></div>
                                </div>
                                <div className="flex justify-between text-xs text-gray-500 mt-1">
                                    <span>1,542 clicks</span>
                                    <span>1.8% CTR</span>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <h4 className="text-sm font-medium">LinkedIn</h4>
                                    <span className="text-sm font-medium text-blue-900">$3.25 CPC</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                    <div className="h-2 bg-blue-900 rounded-full" style={{width: '18%'}}></div>
                                </div>
                                <div className="flex justify-between text-xs text-gray-500 mt-1">
                                    <span>421 clicks</span>
                                    <span>0.9% CTR</span>
                                </div>
                            </div>

                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <h4 className="text-sm font-medium">Email</h4>
                                    <span className="text-sm font-medium text-green-600">$0.12 CPC</span>
                                </div>
                                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                                    <div className="h-2 bg-green-600 rounded-full" style={{width: '89%'}}></div>
                                </div>
                                <div className="flex justify-between text-xs text-gray-500 mt-1">
                                    <span>1,874 clicks</span>
                                    <span>4.2% CTR</span>
                                </div>
                            </div>

                            <button className="text-sm text-blue-600 font-medium flex items-center mt-2">
                                View All Channels
                                <ArrowRight size={14} className="ml-1" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Fourth Row - AI Insights */}
                <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200 mb-6">
                    <div className="flex items-center mb-4">
                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                            <Zap size={18} className="text-blue-600" />
                        </div>
                        <h3 className="font-medium text-gray-800">GlowSight AI Insights</h3>
                    </div>
                    <div className="space-y-4">
                        <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                                    <TrendingUp size={16} className="text-blue-600" />
                                </div>
                                <div>
                                    <h4 className="font-medium text-blue-800 mb-1">Significant Traffic Increase from Instagram</h4>
                                    <p className="text-sm text-blue-700">We've detected a 32% increase in traffic from Instagram over the past week, coinciding with your recent story campaign. This channel is now your second highest traffic source.</p>
                                    <button className="text-xs text-blue-600 font-medium mt-2 flex items-center">
                                        View Detailed Analysis
                                        <ArrowRight size={12} className="ml-1" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-100">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
                                    <TrendingDown size={16} className="text-yellow-600" />
                                </div>
                                <div>
                                    <h4 className="font-medium text-yellow-800 mb-1">Conversion Rate Declining on Mobile Devices</h4>
                                    <p className="text-sm text-yellow-700">Mobile conversion rates have dropped by 0.8% this month. Our analysis suggests checkout page load times on mobile have increased by 2.3 seconds, which may be contributing to abandonment.</p>
                                    <button className="text-xs text-yellow-600 font-medium mt-2 flex items-center">
                                        View Recommendations
                                        <ArrowRight size={12} className="ml-1" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button className="flex items-center justify-center w-full py-2 text-blue-600 font-medium border border-blue-200 rounded-md hover:bg-blue-50">
                            <Plus size={16} className="mr-2" />
                            Ask GlowSight AI a Question
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LumiLogicDashboardDetail;